import Quill from "quill";
import { ArquivoBinario } from "./arquivo-binario.model";
import { Anotacao } from "./anotacao.model";
import { EstiloSegmento } from "./estilo-segmento.model";
import { SafeHtml } from "@angular/platform-browser";

export class Segmento {
    idAto: number | null;
    idSegmento: number | null;
    versaoSegmento: number;
    original: boolean;
    compilado: boolean;

    idTipoSegmento: number | null;
    idAssunto: number;
    ordemSegmentoAto: number;

    textoIntegra: string;
    arquivoBinario: ArquivoBinario;

    agendado: boolean;
    ultimo: boolean;
    ultimaVersaoEmenta = false;

    estiloSegmento: EstiloSegmento;
}

export const EXIBIR_COMO_EDITOR = 1;
export const EXIBIR_COMO_HTML = 2;
export const EXIBIR_COMO_ICONE = 3;
export const EXIBIR_COMO_BASE64 = 4;

export class SegmentoTela {
    idSegmento: number | null;
    versaoSegmento = 1;
    original = true;
    compilado = true;

    idTipoSegmento: number | null = 999;
    idAssunto = 1;

    textoIntegra = '';
    innerHTML = '';
    classe = '';
    editor: Quill | null = null;
    anexo: File;
    arquivoBinario: ArquivoBinario;
    // Sanitiza o HTML das tabelas para garantir que o estilo próprio da tabela seja aplicado
    innerHTMLSanitizado: SafeHtml;

    exibirComo = EXIBIR_COMO_EDITOR;
    anotacoesComoOrigem: Anotacao[] = [];
    anotacoesComoDestino: Anotacao[] = [];
    versionado = false;
    anotado = false;

    ordemSegmentoAto: number;

    // demanda de estilo segmento
    estiloSegmento: EstiloSegmento;
    style = {};

    // relato-lentidao
    visivel = false;
    fresh = true;

    // inconsistencia segmento tipo anexo
    anexoInconsistente = false;

    clone(): SegmentoTela {
        const clone = Object.assign(new SegmentoTela(), this);
        clone.editor = null;
        return clone;
    }
}
